
namespace TabAurous.ECommerce {

    @Serenity.Decorators.registerClass()
    @Serenity.Decorators.panel()
    export class PickUpDialog extends _Ext.TransDialog<PickUpRow, any> {

        protected getFormKey() { return PickUpForm.formKey; }
        protected getIdProperty() { return PickUpRow.idProperty; }
        protected getLocalTextPrefix() { return PickUpRow.localTextPrefix; }
        protected getNameProperty() { return PickUpRow.nameProperty; }
        protected getService() { return PickUpService.baseUrl; }
        protected getDeletePermission() { return PickUpRow.deletePermission; }
        protected getInsertPermission() { return PickUpRow.insertPermission; }
        protected getUpdatePermission() { return PickUpRow.updatePermission; }
        protected useViewMode() { return true; }

        public form = new PickUpForm(this.idPrefix);
        public RateListId: number;
        public LaborListId: number;
        public StoneMarkup: number;
        public StoneDiscount: number;
        public LaborMarkup: number;
        public LaborDiscount: number;
        public ExchangeRate: number;

        statement: string;
        contractTotals: string; 
        MaxDate: Date;
        MinDate: Date;

        constructor() {
            super();
            //Make grid full width
            var Config = Q.deepClone(q.DefualtEditorOptions);
            Config.height = 150;
            q.initItemEditor(this, this.form.ItemDetails, Config);

            //Make grid full width
            q.hideEditorLabel(this.form.ItemDetails);
            q.hideEditorLabel(this.form.ItemDetails);
            q.setTextRightAlign(this.form.Pieces);
            q.setTextRightAlign(this.form.Weight);
            q.setTextRightAlign(this.form.NetWeight);
            q.setTextRightAlign(this.form.NetAmount);
            q.setTextRightAlign(this.form.AdditionalCharges);
            q.setTextRightAlign(this.form.GrossAmount);
            q.setTextRightAlign(this.form.Discount);
            q.setTextRightAlign(this.form.ReceiptAmount);
            q.setGridEditorHeight(this.form.ItemDetails, 300);

            q.SetCategorySixColumn(this.form.TransDate);
            q.SetCategoryFourColumn(this.form.BillNo);
            q.SetCategoryFullWidth(this.form.ItemDetails);
            q.SetSix12Column(this.form.FinancialYearId);
            q.SetCategoryTwoColumn(this.form.Pieces);
            q.SetCategoryFourColumn(this.form.NetAmount);
            q.SetCategoryFullWidth(this.form.Remark);
            q.HideCategoryLable(this.element);
            var fieldEditor: JQuery = this.form.POSCustomerId.element.closest(".editor");
            fieldEditor.addClass("has-inplace-button");
            $(' <button type="button">...</button>')
                .addClass('inplace-button')
                .addClass('inplace-search edit')
                .attr('title', 'Search')
                .insertAfter(fieldEditor)
                .click((e) => { this.inplaceSearchClick(e) }
                );
            // **** Get Party Details using PartyID **** 
            this.form.POSCustomerId.changeSelect2(e => {
                var cid = parseInt(this.form.POSCustomerId.value);
                if (cid > 0) {
                    let CustomerDetails: OMS.PosCustomerMasterRow
                    OMS.PosCustomerMasterService.Retrieve({ EntityId: cid }, response => { CustomerDetails = response.Entity }, { async: false });
                    var firstname = CustomerDetails.FirstName == undefined ? "" : CustomerDetails.FirstName;
                    var lastname = CustomerDetails.LastName == undefined ? "" : CustomerDetails.LastName;
                    this.form.CustomerName.value = firstname + " " + lastname;
                    this.form.ItemDetails.PartyId = parseInt(this.form.PartyId.value.toString());
                    this.form.GrossAmount.value = 0;
                }
            });
            this.form.ItemDetails.slickGrid.setOptions({ forceFitColumns: true });
             

            this.form.CountryId.changeSelect2(e => {
                this.form.StateId.cascadeField = "CountryId";
                this.form.StateId.cascadeValue = this.form.CountryId.value;
                this.form.CityId.cascadeField = "StateId";
                this.form.CityId.cascadeValue = this.form.StateId.value;
                //this.form.CountryId.cascadeField = "id";
                //this.form.NationalityId.cascadeValue = this.form.CountryId.value

                Serenity.EditorUtils.setReadOnly(this.form.StateId, false);

            });
            this.form.StateId.changeSelect2(e => {
                this.form.CityId.cascadeField = "StateId";
                this.form.CityId.cascadeValue = this.form.StateId.value;
                Serenity.EditorUtils.setReadOnly(this.form.CityId, false);

            });


            // **** Calculate Net,Gross Amount, Discount and Tax from Item Details and show on form ****
            var ItemTotal = 0;
            var Items: any;
            var Receipts: any;
            (this.form.ItemDetails.view as any).onRowCountChanged.subscribe(() => {
                Items = this.form.ItemDetails.getItems();

                var TotalItems = this.form.ItemDetails.getTotalRows();
                if (ItemTotal > 0) {
                    ItemTotal = 0;
                }

                this.CalculateAmountandTax(Items, TotalItems);

            })


            this.form.GrossAmount.addValidationRule(this.uniqueName, e => {
                //Validate that the knock off value is not less than or greater than total Amount
                if (this.form.ItemDetails.getItems().length == 0) {
                    Q.alert("There are no Items added in transaction. Can not save!!")
                    return "";
                }
            });

            this.validateForm();

        }

        public CalculateAmountandTax(Items: any, TotalItems: number) {
            if (!this.isViewMode()) {

                var codearray = [];
                var amtarray = [];
                var TaxDetail = [];
                var ItemTotal = 0;
                var ntamt = 0; var gramt = 0; var disc = 0; var tax = 0; var pcs = 0; var nwt = 0; var wt = 0;

                //Items.forEach(function (x)
                for (var x of Items) {
                    ntamt += x.NetAmount || 0;
                    gramt += x.GrossAmount || 0;
                    disc += x.Discount || 0;
                    pcs += x.Pieces || 0;
                    wt += x.Weight || 0;
                    nwt += x.NetWeight || 0;

                    if (x.HSN != null || x.HSN != "NA") {
                        var temp = false;
                        for (let i = 0; i < codearray.length; i++) {
                            if (codearray[i] == x.HSN) {
                                amtarray[i] += x.GrossAmount || 0;
                                temp = true;
                            }
                        }

                        if (!temp) {
                            codearray.push(x.HSN);
                            amtarray.push(x.GrossAmount);
                        }
                    }
                    ItemTotal++;
                };

                this.form.NetAmount.value = gramt;
                this.form.Discount.value = disc;

                if (ItemTotal == TotalItems) {

                    //this.form.TaxAmount.value = TaxAmount;
                    this.form.GrossAmount.value = gramt;
                    this.form.Pieces.value = pcs;
                    this.form.Weight.value = wt;
                    this.form.NetWeight.value = nwt;
                }
                else {
                    this.form.GrossAmount.value = gramt;
                    this.form.Pieces.value = pcs;
                    this.form.Weight.value = wt;
                    this.form.NetWeight.value = nwt;
                }

                this.form.ItemDetails.render;
            }
        }


        protected inplaceSearchClick(e: any): void {
            var T = this.isViewMode();

            if (!this.isViewMode()) {
                if (this.form.ItemDetails.getItems().length == 0) {
                    var grid = Common.AddressSelectGrid;
                    var filters: _Ext.SelectGridFilters = {
                        CustomerId: Q.parseInteger(this.form.POSCustomerId.value)
                    }
                    var pickerDialog = new _Ext.GridItemPickerDialog({
                        gridType: grid, multiple: false, title: "Select Address", GridFilters: filters
                    });

                    pickerDialog.onSuccess = (selectedItems: ECommerce.ECommOrderAddressRow[]) => {

                        if (selectedItems.length > 0) {
                            var AddressDetails = selectedItems[0];

                            if (AddressDetails != null) {

                                this.form.CountryId.value = AddressDetails.Country.toString();
                                this.form.StateId.value = AddressDetails.State.toString();
                                this.form.CityId.value = AddressDetails.City.toString();
                                this.form.Pin.value = AddressDetails.Pincode;
                                this.form.Address.value = AddressDetails.Address1;
                            }
                        }
                    }
                    pickerDialog.dialogOpen();
                }
                else
                    q.Alert("Not Allowed", "Party can not be changed while items are added", 2000, false);
            }
            else {
                q.Alert("View Mode", "Can not make changes in view mode", 2000, false);
            }
        }



        protected getToolbarButtons(): Serenity.ToolButton[] {
            let btns = super.getToolbarButtons();
            var btnDelete = Q.first(btns, x => x.cssClass == "delete-button");
            var oldDeleteClick = btnDelete.onClick;
            btnDelete.onClick = e => { this.confirmBeforeDelete(oldDeleteClick, e); };

            //Edit Click Override
            var btnEdit = Q.first(btns, x => x.cssClass == "edit-button");
            var oldEditClick = btnEdit.onClick;
            btnEdit.onClick = e => { this.confirmBeforeEdit(oldEditClick, e); };

            //Export PDF Button
            btns.push(TabAurous.Common.ReportHelper.createToolButton({
                title: 'Print',
                cssClass: 'export-pdf-button',
                icon: 'fa fa-print text-blue',
                reportKey: 'ECommerce.PickUpVoucher',
                getParams: () => ({
                    TransID: this.get_entityId()
                })
            }));


            return btns;
        }
        // **** Validate Reference of Voucher in Stock Transaction Before Edit. ****
        private confirmBeforeEdit(oldEvt, e) {
            let self = this;
            let refid: Stock.StockItemRow;
            Stock.StockItemService.CheckTransaction(
                { RefTransId: parseInt(this.form.TransId.value), RefVoucherId: this.form.VoucherTypeId.value },
                response => {
                    if (response.Entities != null && response.Entities.length > 0)
                        refid = response.Entities[0];
                }, { async: false }
            )
            if (refid != null) {
                if (refid.ProductName != null || refid.ProductName != "") {
                    Q.alert("This Voucher has been used in transactions Can Not Delete!");
                    return;
                }
            } else {
                Serenity.EditorUtils.setReadonly(this.form.ItemDetails.element, false);
                this.form.ItemDetails.canUpdate = 1;
                if (!self.isEditMode())
                    return;
                self.editClicked = true;
                self.updateInterface();
                self.updateTitle();
            }
        }
        // **** Validate Reference of Voucher in Stock Transaction Before Delete. ****
        private confirmBeforeDelete(oldEvt, e) {
            let self = this;
            let refid: Stock.StockItemRow;
            Stock.StockItemService.CheckTransaction(
                { RefTransId: parseInt(this.form.TransId.value), RefVoucherId: this.form.VoucherTypeId.value },
                response => {
                    if (response.Entities != null && response.Entities.length > 0)
                        refid = response.Entities[0];
                }, { async: false }
            )
            if (refid != null) {
                if (refid.PartyId != null || refid.PartyId > 0) {
                    Q.alert("This Voucher has been used in transactions Can Not Delete!");
                    return;
                }
            } else {
                PickUpService.Delete(
                    {
                        EntityId: this.entityId
                    }, response => {
                        Serenity.SubDialogHelper.triggerDataChange(self);
                        self.dialogClose();
                        window.setTimeout(() => Q.notifySuccess(Q.text('Deleted successfully')), 0);
                    });
            }

        }

        validateBeforeSave() {
            var Isvalid = super.validateBeforeSave();
            if (this.form.ItemDetails.getItems().length == 0) {
                Q.alert("No Items added, At least add one entry. Can not Save! ")
                Isvalid = false;
            }


            return Isvalid;

        } 


        validateEntity(row: ECommerce.PickUpRow, id: number) {

            if (row.ItemDetails.length == 0) {
                Q.alert("No Items added, Atleast add one entry. Can not Save! ")
                return false;
            }
            var items = this.form.ItemDetails.getItems();
            for (var i = 0; i < items.length; i++) {
                var item = items[i];
                item.BagNo = item.BagNo == undefined ? "NA" : item.BagNo;
                item.LotNo = item.LotNo == undefined ? "NA" : item.LotNo;
                item.SKU = item.SKU == undefined ? "0" : item.SKU;
                item.RefVoucherId = item.RefVoucherId == null? 0 : item.RefVoucherId;
                item.RefTransId = item.RefTransId == null? 0 : item.RefTransId;
                item.RefTransItemId = item.RefTransItemId == null? 0 : item.RefTransItemId;
                item.RefNo = item.RefNo == undefined ? "0" : item.RefNo;
                item.DepartmentId = item.DepartmentId == null ? 0 : item.DepartmentId;
                item.CertificateNo = item.CertificateNo == undefined ? "NA" : item.CertificateNo;
                item.Lab = item.Lab == undefined ? "NA" : item.Lab;
                item.MetalAmount = item.MetalAmount == null? 0 : item.MetalAmount;
                item.DiamondAmount = item.DiamondAmount == null? 0 : item.DiamondAmount;
                item.StoneAmount = item.StoneAmount == null? 0 : item.StoneAmount;
                item.OtherAmount = item.OtherAmount == undefined ? 0 : item.OtherAmount;
            }

        }
    }
}